export enum OrderStatus {
  draft = "DRAFT",
  pending = "PENDING",
  inProgress = "INPROGRESS",
  confirmed = "CONFIRMED",
  cancelled = "CANCELLED",
  noShow = "NO_SHOW",
  complete = "COMPLETE",
}

export enum PaymentStatus {
  paymentPending = "PAYMENT_PENDING",
  pendingTpaApproval = "PENDING_TPA_APPROVAL",
  paid = "PAID",
  failed = "FAILED",
}

export enum OrderItemPlanningTab {
  all = "ALL",
  upcoming = "UPCOMING",
  completed = "COMPLETED",
  draft = "DRAFT",
  cancelled = "CANCELLED",
  pending = "PENDING",
  confirmed = "CONFIRMED",
  rescheduled = "RESCHEDULED",
}

export enum OrderItemStatus {
  DRAFT = "DRAFT",
  NO_SHOW = "NO_SHOW",
  PENDING = "PENDING",
  INPROGRESS = "INPROGRESS",
  COMPLETE = "COMPLETE",
  CANCELLED = "CANCELLED",
  RESCHEDULED = "RESCHEDULED",
}

export enum OrderItemUnifiedStatus {
  DRAFT = "DRAFT",
  CONFIRMED = "CONFIRMED",
  PENDING = "PENDING",
  NO_SHOW = "NO_SHOW",
  COMPLETE = "COMPLETE",
  CANCELLED = "CANCELLED",
  CHECKED_IN = "CHECKED_IN",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  PAYMENT_PENDING = "PAYMENT_PENDING",
  PENDING_TPA_APPROVAL = "PENDING_TPA_APPROVAL",
}

export enum TpaApprovalStatus {
  pendingTpaApproval = "PENDING_TPA_APPROVAL",
  approvedForBilling = "APPROVED_FOR_BILLING",
  rejectedByTpa = "REJECTED_BY_TPA",
  removedByPartner = "REMOVED_BY_PARTNER",
  needsReview = "NEEDS_REVIEW",
}

export enum TpaAdditionalServiceApprovalStatus {
  approve = "approve",
  reject = "reject",
  needsReview = "needs-review",
}

export enum BookerSubscriptionPlan {
  free = "FREE",
  plus = "PLUS",
  premium = "PREMIUM",
}
